import { render, staticRenderFns } from "./SiteFooter.vue?vue&type=template&id=5fc6ce38&scoped=true&comments=true&"
import script from "./SiteFooter.vue?vue&type=script&lang=js&"
export * from "./SiteFooter.vue?vue&type=script&lang=js&"
import style0 from "./SiteFooter.vue?vue&type=style&index=0&id=5fc6ce38&prod&lang=scss&scoped=true&"
import style1 from "./SiteFooter.vue?vue&type=style&index=1&id=5fc6ce38&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc6ce38",
  null
  
)

export default component.exports